module.exports = __webpack_public_path__ + "static/dummy-88e812302cfe2b9227e1d3d4e5ee1c1c.png";